<h2 mat-dialog-title>Session expirée</h2>
<mat-dialog-content>Veuillez recharger votre page.</mat-dialog-content>
<mat-dialog-actions>
  <button data-test="session-timeout-dialog-btn" mat-button color="primary" (click)="reloadPage()">
    Recharger
  </button>
</mat-dialog-actions>
